<template>
  <div class="video_page">
    <head-top head-title="视频详情" goBack="true"></head-top>
    <div class="video_box">
      <video width="100%" height="240" controls>
        <source :src="url"  type="video/mp4">
      </video>
    </div>
  </div>
</template>

<script>
  import headTop from '../header/Header'
  export default {
    name: 'videoPage',
    data () {
      return {
        url: ''
      }
    },
    created () {
      this.url = decodeURIComponent(this.$route.query.url)
    },
    methods: {},
    components: {
      headTop
    }
  }
</script>

<style lang="scss" scoped>
.video_page{
  width: 100%;
  .video_box{
    width: 100%;
    background-image: linear-gradient(#ffffff,#ffffff, rgba(29, 29, 29, 1));
  }
}
</style>



// WEBPACK FOOTER //
// src/components/home/videoPage.vue